import styled from "styled-components";
import { Colors } from "./theme";
import MobileMenu from "./menu/MobileMenu";
import { useMediaQuery } from "react-responsive";

const BodyStyle = styled.div `
    top: 30px;
    position: relative;
    @media (min-width: 880px) {
        top: 95px;
    }
`

const SideMenu = styled.div `
    display: none;
    position: sticky;
    z-index: 0;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    padding: 30px 30px;
    color: ${Colors.white};
    @media (min-width: 880px) {
        width: 235px;
        display: block;
        background-color: ${Colors.red};
    }
`;

const PageContentStyle = styled.div `
    margin: 0px 10px;
    padding-bottom: 5px;
    @media (min-width: 880px) {
        margin: 0px 30px;
    }
`

function ContentBodyStyle({menu, routes}) {
    const isMobile = useMediaQuery({ maxWidth: 991 });

    return (
        <BodyStyle className="container-fluid">
            <div className="row flex-nowrap">
                {!isMobile && (
                    <div className="col px-0 d-none d-lg-block" style={{ maxWidth: "235px" }}>
                        <SideMenu>{menu}</SideMenu>
                    </div>
                )}

                {isMobile && <MobileMenu>{menu}</MobileMenu>} 
                               
                <div className="col" style={{overflowX:"auto"}}>
                    <PageContentStyle>
                        {routes}
                    </PageContentStyle>
                </div>                    
            </div>
        </BodyStyle>
    )
};

export default ContentBodyStyle;